import { safeHref } from './formatters';

/**
 * Popup for the tapered approach corridor.
 *
 * Mirrors utils/power-line-safety.js, including its tone: say where the number comes
 * from, and say plainly what the zone is not. @JaroSubaru82 asked about CTR/DRA zones
 * and this is not one — calling it that would be misleading and would come straight
 * back in the comments.
 */
export function buildAirportCorridorHtml(props, esc) {
    var name = props.airport_name ? String(props.airport_name) : '';
    var extendKm = props.extend_km != null ? String(props.extend_km) : '15';
    var widthKm = props.width_km != null ? String(props.width_km) : '3';
    var lines = [];
    lines.push('<div class="nm-popup-card nm-popup-card--airport-corridor">');
    lines.push('<div class="nm-popup-kicker">Orientacyjny korytarz podejścia</div>');
    lines.push('<div class="nm-popup-title">Tu samoloty przelatują nisko</div>');
    if (name !== '') {
        lines.push('<div class="nm-popup-summary">' + esc(name) + '</div>');
    }
    lines.push('<p class="nm-popup-copy">Dwa korytarze pokazują '
        + 'przedłużenie osi pasa startowego o ' + esc(extendKm) + ' km z każdej strony. '
        + 'Przy końcu pasa mają około ' + esc(widthKm) + ' km szerokości i zwężają się'
        + ' liniowo wraz z odległością od lotniska. Samoloty startujące i lądujące przelatują zwykle'
        + ' właśnie tędy najniżej, więc'
        + ' hałas jest tu wyraźnie większy, niż wynikałoby z odległości od samego lotniska.</p>');
    lines.push('<p class="nm-popup-copy"><b>To nie jest</b> strefa kontrolowana lotniska (CTR), obszar ograniczonego'
        + ' użytkowania ani mapa hałasu. Nie uwzględnia rzeczywistych procedur podejścia,'
        + ' liczby operacji, pory dnia ani typu statków powietrznych. Realne tory lotu bywają'
        + ' krzywoliniowe, a przy lotniskach z kilkoma pasami korytarze się krzyżują.</p>');
    lines.push('<p class="nm-popup-copy">Przed zakupem sprawdź uchwałę o obszarze ograniczonego'
        + ' użytkowania dla tego lotniska i — jeśli możesz — posłuchaj na miejscu w godzinach'
        + ' szczytu, o różnych porach dnia.</p>');
    var detailUrl = safeHref(props.detail_url);
    if (detailUrl) {
        lines.push('<a class="nm-popup-link" href="' + esc(detailUrl) + '">Pełne szczegóły lotniska</a>');
    }
    lines.push('</div>');

    return lines.join('');
}

/**
 * Short inline note for the nearby-objects card, where there is no room for the popup.
 */
export function buildAirportCorridorNoteHtml(corridor, esc) {
    if (!corridor) return '';
    var extendKm = corridor.extend_km != null ? String(corridor.extend_km) : '15';

    return '<div class="nm-airport-corridor-notice">'
        + '<span class="nm-airport-corridor-icon" aria-hidden="true">&#9992;</span> '
        + 'W zwężającym się korytarzu podejścia — do ' + esc(extendKm) + ' km od pasa'
        + '</div>';
}
